import { catchErrors, skipForDevelopment, skipForPrerender } from "shared/mechanics/decorators";
import { Logger } from "shared/mechanics/logging";
import { IPlugin } from "shared/mechanics/plugin";

import { initGoogleAnalytics, initGoogleTagManager } from './external-code';

declare const gtag: any;
declare const ga: any;

const measurementId = process.env.REACT_APP_INTEGRATION_GOOGLE_MEASUREMENT_ID;

export interface IGoogleAnalyticsPlugin extends IPlugin {
	trackVisit(visitUrl: string): void;
}

export class GoogleAnalyticsPlugin implements IGoogleAnalyticsPlugin {
	isInitialized: boolean = false;
	name: string = 'Google Analytics';

	@catchErrors
	@skipForPrerender
	@skipForDevelopment
	init(): void {
		initGoogleTagManager(measurementId);
		initGoogleAnalytics();

		gtag('js', new Date());
		gtag('config', measurementId);

		this.isInitialized = true;
	}

	@catchErrors
	@skipForPrerender
	@skipForDevelopment
	trackVisit(visitUrl: string): void {
		if (!this.isInitialized) {
			Logger.logWarning('Google analytics was not initialized');
			return;
		}

		ga('set', 'page', visitUrl);
		ga('send', 'pageView');
	}
}